var map = {
	"./ASC.svg": 68667,
	"./DESC.svg": 25279,
	"./app-install.svg": 43117,
	"./brand-awareness.svg": 60562,
	"./customer-loyalty.svg": 83772,
	"./engagement.svg": 98313,
	"./female.svg": 51424,
	"./icon-filter.svg": 28614,
	"./lead-generation.svg": 14587,
	"./male.svg": 83881,
	"./man_12_18.svg": 65285,
	"./man_18_25.svg": 31757,
	"./man_25_35.svg": 47081,
	"./man_35_45.svg": 25443,
	"./man_45plus.svg": 34636,
	"./private.svg": 30681,
	"./product-launch.svg": 23787,
	"./public.svg": 30608,
	"./purchases-sales.svg": 1655,
	"./store-opening.svg": 32029,
	"./traffic.svg": 62286,
	"./woman_12_18.svg": 35708,
	"./woman_18_25.svg": 95873,
	"./woman_25_35.svg": 71271,
	"./woman_35_45.svg": 46800,
	"./woman_45plus.svg": 70682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36253;